export default {
      id: "ar_location-usage",
      viewBox: "0 0 75 75",
      url: "../dist/images/" + "sprite.svg#ar_location-usage",
      toString: function () {
        return this.url;
      }
    }